import { useMemo } from "react";

import { ButtonGroup, ToggleButton } from "react-bootstrap";
import { Controller, useController, UseControllerProps } from "react-hook-form";

import { ErrorForm } from "./ErrorForm.tsx";
import { LabelForm, LabelFormProps } from "./LabelForm.tsx";


type ToggleButtonFormProps = {
  leftToggle: string;
  rightToggle: string;
} & LabelFormProps &
  UseControllerProps;

const ToggleButtonForm = (props: ToggleButtonFormProps) => {
  const { field } = useController(props);

  useMemo(
    () => (field.value ? field.onChange(true) : field.onChange(false)),
    [],
  );

  return (
    <div className="form-input">
      <LabelForm
        label={props.label}
        required={!!props.rules?.required}
        labelInfos={props.labelInfos}
      />
      <Controller
        control={props.control}
        name={props.name}
        defaultValue={props.defaultValue}
        rules={props.rules}
        render={({ field, fieldState }) => {
          return (
            <>
              <ButtonGroup className="d-flex flex-row flex-nowrap">
                <ToggleButton
                  id={`tbg-btn-left-${props.name}`}
                  className="switch-dwelling-prop ms-1 switch-dwell-left"
                  checked={field.value}
                  type="radio"
                  onClick={() => field.onChange(true)}
                  value={1}
                >
                  {props.leftToggle}
                </ToggleButton>
                <ToggleButton
                  id={`tbg-btn-right-${props.name}`}
                  className="switch-dwelling-prop ms-1 switch-dwell-right"
                  checked={!field.value}
                  type="radio"
                  onClick={() => field.onChange(false)}
                  value={0}
                >
                  {props.rightToggle}
                </ToggleButton>
              </ButtonGroup>
              <ErrorForm error={fieldState.error} />
            </>
          );
        }}
      />
    </div>
  );
};

export default ToggleButtonForm;
